import { memo, useContext, createElement } from '@max/max';
import View from '@hfe/max-view';
import Image from '@max/leez-image';
import Text from '@hfe/max-text';
import LinearGradient from '@hfe/max-linear-gradient';
import './index.scss';
import { onHotCityRouteClick } from '../../utils/index';
const ImageCard = (props) => {
    const { city, hotCityCornerMode, hotCityCornerTextColor, hotCityCornerTextBgColor, hotCityCornerText } = props;
    const ctx = useContext(global._EngineGlobalContext);
    const reportClickCardMC = city => {
        var _a;
        const val_lab = {
            custom: {
                component_name: '火车票千人千面组件',
                depart_city_name: city.fromCityNameText,
                arrive_city_name: city.toCityNameText,
                mode: '有图模式'
            }
        };
        (_a = ctx._LXReport) === null || _a === void 0 ? void 0 : _a.mcReport('b_daodian_lowcode_npt6cewk_mc', {
            valLab: val_lab
        });
        onHotCityRouteClick(city);
    };
    return <View className="hot-city-block" onClick={() => reportClickCardMC(city)}>
      <LinearGradient className="hot-city-image-container" start={{
        x: 1,
        y: 0
    }} end={{
        x: 1,
        y: 1
    }} colors={['rgba(255, 255, 255, 0)', 'rgba(255, 255, 255, 0.2)']}>
        <Image className="hot-city-image" source={{
        uri: city.imageUrl
    }}/>
        <View className="hot-city-image-footer">
          <LinearGradient className="hot-city-image-footer-gradient" start={{
        x: 1,
        y: 0
    }} end={{
        x: 1,
        y: 1
    }} colors={['rgba(0,0,0,0)', 'rgba(1,1,1,1)']}/>
          <View className="hot-city-image-footer-content">
            <View className="hot-city-image-footer-name-price">
              <Text className="hot-city-image-footer-name">
                {city.fromCityName}-{city.toCityName}
              </Text>
              <Text className="hot-city-image-footer-price">￥{city.priceText}</Text>
            </View>
            <Text className="hot-city-duration">最快仅需{city.runTime}</Text>
          </View>
        </View>
        <View x-if={hotCityCornerMode < 2} className="hot-city-image-corner" style={{
        backgroundColor: hotCityCornerTextBgColor
    }}>
          <Text x-if={city.imageCornerText} className="hot-city-image-corner-text" style={{
        color: hotCityCornerTextColor,
        fontFamily: 'PingFangSC-Regular'
    }}>
            {city.imageCornerText}
          </Text>
        </View>
      </LinearGradient>

      
      
      
      
      
    </View>;
};
export default memo(ImageCard);
